(function () {
    "use strict";
    angular.module('archie.core')
        .directive('shareUrl', ShareUrlDirective);
    function ShareUrlDirective($mdPanel) {
        return {
            'restrict': 'E',
            'replace': true,
            'transclude': true,
            'templateUrl': 'layout/share-url/share-url.html',
            'scope': {
                'url': '=',
                'relativeTo': '@?',
                'xposition': '@?',
                'yposition': '@?',
                'attachTo': '=?',
                'toggleOn': '=?',
                'trapFocus': '=?' // (optional) prevent user from interacting with the rest of the page until the panel is closed, default false
            },
            'controller': 'ShareUrlController'
        };
    }
})();
